import { EPaymentStatus, getPaymentStatus } from '../../../services/billingPayments';
import {
  TUpdateDepositAccountPaymentStatusAction,
  TUpdateDepositAccountRecommendedPackagePaymentStatusAction,
} from '../../../actions/depositAccount';
import { checkServiceAfterFillBalance } from '../../../actions/checkoutInfo';
import { TThunkAction } from '../../../../common/types/thunk';
import { runBuyPackageLegacyThunk } from '../../runBuyPackageLegacy';
import { loadPublishTerms } from '../../publishTerms/loadPublishTerms';
import { EPaymentProvider } from '../../../../PaymentWidgetMicrofrontend';
import { sleep } from '../../../../common/utils/sleep';
import { selectConfigValue } from '../../../selectors/config';
import { selectIsRecommendedPackageCheckoutFillBalance } from '../../../reducers/v2/recommendedPackages/selectors';

type TSetStatus = {
  (status: EPaymentStatus | null):
    | TUpdateDepositAccountRecommendedPackagePaymentStatusAction
    | TUpdateDepositAccountPaymentStatusAction;
};

interface IParams {
  setStatusAction: TSetStatus;
  paymentId: string;
  provider: EPaymentProvider;
}

const threeSeconds = 3 * 1000;

export const checkPaymentStatus =
  (params: IParams): TThunkAction<Promise<EPaymentStatus>> =>
  async (dispatch, getState, { httpApi }) => {
    const { setStatusAction, paymentId, provider } = params;

    const state = getState();
    const isRecommendedPackageCheckoutFillBalance = selectIsRecommendedPackageCheckoutFillBalance(state);
    const loadPublishTermsTimeout = selectConfigValue('loadPublishTermsAfterBuyPackageTimeout')(state);

    dispatch(setStatusAction(EPaymentStatus.Pending));

    const { status } = await getPaymentStatus({ httpApi, paymentId, provider });

    if (status === EPaymentStatus.Pending) {
      return new Promise(resolve => {
        setTimeout(() => {
          const result = dispatch(checkPaymentStatus({ setStatusAction, paymentId, provider }));

          resolve(result);
        }, threeSeconds);
      });
    }

    if (status === EPaymentStatus.Succeeded) {
      if (isRecommendedPackageCheckoutFillBalance) {
        dispatch(runBuyPackageLegacyThunk());
      } else {
        // Костыль чтобы дать время на покупку пакета на бэке после оплаты
        await sleep(loadPublishTermsTimeout);

        await dispatch(loadPublishTerms());
      }

      dispatch(checkServiceAfterFillBalance());
      dispatch(setStatusAction(null));
    }

    return Promise.resolve(status);
  };
